import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=ca094b52"
import script from "./?vue&type=script&lang=js&external"
export * from "./?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports